import { render } from "./Edit.vue?vue&type=template&id=876f47ec&scoped=true"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=876f47ec&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876f47ec"],['__file',"resources/js/Pages/ItemAssets/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "876f47ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('876f47ec', __exports__)) {
    console.log('reload')
    api.reload('876f47ec', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=876f47ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('876f47ec', render)
  })

}


export default __exports__